import React from 'react';
import {
  BridgeContainer,
  BridgeContent,
  MainTitle,
  Subtitle,
  Description,
  HighlightedText,
  PhoneImageSection,
  PhoneImage,
  ContentSection,
  TextContent,
  AvatarContent,
  AvatarGroup,
  PhoneTitle,
  BenefitsList,
  BenefitItem,
  BenefitIcon,
  BenefitText,
  BottomSection,
  BottomTitle,
  BottomDescription
} from './styles';

// Importando as imagens
import containerImage from '../../../assets/images/container.png';
import avatarGroupImage from '../../../assets/images/Avatargroup.png';

const ProducerBridge = () => {
  return (
    <BridgeContainer>
      <BridgeContent>
        <MainTitle>Vende donde nadie más puede llegar.</MainTitle>
        
        <Subtitle>Con Floqss, tus infoproductos alcanzan a millones sin tarjetas ni acceso digital.</Subtitle>
        
        <Description>
          En Colombia, más de la mitad de la población no compra infoproductos simplemente porque no tiene cuenta bancaria, tarjeta de crédito o no confía en las compras online. Con Floqss, eso deja de ser un obstáculo.
        </Description>
        
        <HighlightedText>
          Con Floqss, vendes a quienes no confían en pagar online: entregamos el acceso físico y cobramos solo al recibir.
        </HighlightedText>
        
        {/* Seção de imagem do smartphone */}
        <PhoneImageSection>
          <PhoneImage>
            <img src={containerImage} alt="Smartphone mockup" />
          </PhoneImage>
        </PhoneImageSection>
        
        {/* Seção de conteúdo */}
        <ContentSection>
          <TextContent>
            <PhoneTitle>
              Con Floqss, añades un botón de 'Pagar al Recibir' a tu oferta actual y vendes a millones que no usan tarjeta. Sin cambiar tu estructura, sin riesgos y con control total.
            </PhoneTitle>
            <BenefitsList>
              <BenefitItem>
                <BenefitIcon>%</BenefitIcon>
                <BenefitText>Activa una nueva vía de ventas sin aumentar tu gasto en publicidad.</BenefitText>
              </BenefitItem>
              <BenefitItem>
                <BenefitIcon>✓</BenefitIcon>
                <BenefitText>Vende más, llega más lejos y transforma más vidas con impacto real.</BenefitText>
              </BenefitItem>
            </BenefitsList>
          </TextContent>
          
          <AvatarContent>
            <AvatarGroup>
              <img src={avatarGroupImage} alt="Avatar group" />
            </AvatarGroup>
          </AvatarContent>
        </ContentSection>
        
        <BottomSection>
          <BottomTitle>
            Donde otros ven límites, tú verás ventas
          </BottomTitle>
          
          <BottomDescription>
            <strong>FLOQSS</strong> te abre la puerta a un mercado olvidado por el comercio digital tradicional. Llega a quienes nunca pudieron comprar antes, y haz crecer tu negocio con una infraestructura pensada para vender más, fácil y sin barreras.
          </BottomDescription>
        </BottomSection>
      </BridgeContent>
    </BridgeContainer>
  );
};

export default ProducerBridge;